// Builds the contents bar on templates that include [data-toc]
// (currently page-about.hbs, where it renders as a sticky horizontal
// rail under the page title) from the h2 anchors Ghost renders in the
// content. Quiet scroll-spy keeps the active section marked.
export default function pageToc() {
    const toc = document.querySelector("[data-toc]");
    const content = document.querySelector("[data-toc-content]");
    if (!toc || !content) return;

    const headings = content.querySelectorAll("h2[id]");
    if (headings.length < 2) {
        toc.remove();
        return;
    }

    const list = document.createElement("ol");
    headings.forEach((h) => {
        const item = document.createElement("li");
        const link = document.createElement("a");
        link.href = "#" + h.id;
        link.textContent = h.textContent;
        item.appendChild(link);
        list.appendChild(item);
    });
    toc.appendChild(list);

    const links = new Map(
        Array.from(list.querySelectorAll("a")).map((a) => [
            a.getAttribute("href").slice(1),
            a,
        ])
    );

    // Active section = last heading at or above the 30%-of-viewport line.
    // Deterministic under anchor jumps and page-bottom clamping, where
    // enter/leave observation goes stale.
    const activate = () => {
        const line = window.innerHeight * 0.3;
        let current = headings[0];
        headings.forEach((h) => {
            if (h.getBoundingClientRect().top <= line + 1) current = h;
        });
        // At page bottom the last sections can never reach the line —
        // treat a fully-scrolled page as being in the final section.
        const atBottom =
            window.innerHeight + window.scrollY >=
            document.documentElement.scrollHeight - 2;
        if (atBottom) current = headings[headings.length - 1];
        links.forEach((a) => a.classList.remove("is-active"));
        links.get(current.id)?.classList.add("is-active");
    };

    let ticking = false;
    document.addEventListener(
        "scroll",
        () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                activate();
                ticking = false;
            });
        },
        { passive: true }
    );

    activate();
}
